var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import styled from "styled-components";
import { getAlignment, getFrameAttributes, getJustification, getSecondaryAxis, getStyledNodeAttributes, getStyledTextAttributes } from "./helpers";
export var ViewComponent = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", "\n \n   export ", "\n \n   > * {\n    width: 100%;\n    height: 100%;\n  }\n"], ["\n  ", "\n  ", "\n \n   export ", "\n \n   > * {\n    width: 100%;\n    height: 100%;\n  }\n"])), function (props) {
  return getFrameAttributes(props.$frame);
}, function (props) {
  return getStyledNodeAttributes(props.$styles, props.isSeparator);
}, function (props) {
  return props.type === "button" && "&:hover { cursor: pointer; }";
});
export var LinearLayoutComponent = styled.div.attrs(function (props) {
  return {
    "data-direction": props.$direction
  };
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: ", ";\n  flex-wrap: nowrap;\n  justify-content: ", ";\n  align-items: ", ";\n  gap: ", "px;\n\n  [data-direction=\"horizontal\"] > && {\n    ", "\n    ", "\n     ", "\n  }\n\n  [data-direction=\"vertical\"] > && {\n    ", "\n    ", "\n  }\n"], ["\n  display: flex;\n  flex-direction: ", ";\n  flex-wrap: nowrap;\n  justify-content: ", ";\n  align-items: ", ";\n  gap: ", "px;\n\n  [data-direction=\"horizontal\"] > && {\n    ", "\n    ", "\n     ", "\n  }\n\n  [data-direction=\"vertical\"] > && {\n    ", "\n    ", "\n  }\n"])), function (props) {
  return props.$direction === "horizontal" ? "row" : "column";
}, function (props) {
  return getJustification(props.$distribution, props.$direction || "vertical", props.$alignment);
}, function (props) {
  return getAlignment(props.$alignment, getSecondaryAxis(props.$direction));
}, function (props) {
  return props.$spacing || 0;
}, function (props) {
  var _a, _b, _c;

  return ((_b = (_a = props.$frame) === null || _a === void 0 ? void 0 : _a.width) === null || _b === void 0 ? void 0 : _b.resize) === "fill" || ((_c = props.$resize) === null || _c === void 0 ? void 0 : _c.width) === "fill" ? "flex: 1;" : "";
}, function (props) {
  var _a, _b, _c;

  return ((_b = (_a = props.$frame) === null || _a === void 0 ? void 0 : _a.height) === null || _b === void 0 ? void 0 : _b.resize) === "fill" || ((_c = props.$resize) === null || _c === void 0 ? void 0 : _c.height) === "fill" ? "align-self: stretch;" : "";
}, function (props) {
  var _a, _b, _c, _d;

  return ((_b = (_a = props.$frame) === null || _a === void 0 ? void 0 : _a.width) === null || _b === void 0 ? void 0 : _b.resize) === "hug" ? "max-width: ".concat((_d = (_c = props.$frame) === null || _c === void 0 ? void 0 : _c.width) === null || _d === void 0 ? void 0 : _d.min, "px;") : "";
}, function (props) {
  var _a;

  return ((_a = props.$resize) === null || _a === void 0 ? void 0 : _a.height) === "fill" ? "flex: 1;" : "";
}, function (props) {
  var _a;

  return ((_a = props.$resize) === null || _a === void 0 ? void 0 : _a.width) === "fill" ? "width: 100%;" : "";
});
export var CollectionViewComponent = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: grid;\n  width: 100%;\n\n  grid-row-gap: ", "px;\n  grid-column-gap: ", "px;\n  grid-template-columns: ", ";\n"], ["\n  display: grid;\n  width: 100%;\n\n  grid-row-gap: ", "px;\n  grid-column-gap: ", "px;\n  grid-template-columns: ", ";\n"])), function (props) {
  var _a;

  return (_a = props.$spacing) === null || _a === void 0 ? void 0 : _a.vertical;
}, function (props) {
  var _a;

  return (_a = props.$spacing) === null || _a === void 0 ? void 0 : _a.horizontal;
}, function (props) {
  var _a;

  return props.$direction === "vertical" ? "100%" : "repeat(auto-fit, minmax(".concat(((_a = props.$sections.cell.width) === null || _a === void 0 ? void 0 : _a.min) || 0, "px, 1fr))");
});
export var ButtonComponent = styled.button(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  background: none;\n  border: none;\n  font-family: inherit;\n  ", "\n  ", "\n\n  ", "\n\n  &:focus {\n    outline: none;\n    box-shadow: none;\n  }\n\n  &:hover {\n    cursor: pointer;\n  }\n\n  &:disabled {\n    background: #e0e0e0 !important;\n    border: 1px solid #e0e0e0 !important;\n  }\n\n  & span {\n    display: inline-block;\n  }\n"], ["\n  background: none;\n  border: none;\n  font-family: inherit;\n  ", "\n  ", "\n\n  ", "\n\n  &:focus {\n    outline: none;\n    box-shadow: none;\n  }\n\n  &:hover {\n    cursor: pointer;\n  }\n\n  &:disabled {\n    background: #e0e0e0 !important;\n    border: 1px solid #e0e0e0 !important;\n  }\n\n  & span {\n    display: inline-block;\n  }\n"])), function (props) {
  return getStyledNodeAttributes(props.$styles);
}, function (props) {
  return getFrameAttributes(props.$frame);
}, function (_a) {
  var sx = _a.sx;

  if ((sx === null || sx === void 0 ? void 0 : sx.buttonStyle) === "rectangular") {
    return "border-radius: 0px;";
  }

  if ((sx === null || sx === void 0 ? void 0 : sx.buttonStyle) === "rounded") {
    return "border-radius: 2px;";
  }

  if ((sx === null || sx === void 0 ? void 0 : sx.buttonStyle) === "pill") {
    return "border-radius: 100px;";
  }

  return null;
});
export var LabelComponent = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  text-align: ", ";\n  ", "\n"], ["\n  text-align: ", ";\n  ", "\n"])), function (props) {
  return props.$alignment;
}, function (props) {
  return getStyledTextAttributes(props.$styles);
});
export var InputComponent = styled.input(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n   background: none;\n   border: none;\n   width: 100%;\n   display: block;\n   caret-color: ", "\n   ", "\n   ::placeholder {\n     ", "\n   }\n "], ["\n   background: none;\n   border: none;\n   width: 100%;\n   display: block;\n   caret-color: ", "\n   ", "\n   ::placeholder {\n     ", "\n   }\n "])), function (props) {
  return props.$cursorColor;
}, function (props) {
  return getStyledTextAttributes(props.$valueStyles);
}, function (props) {
  return getStyledTextAttributes(props.$placeholderStyles);
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;